<template>
   <kst-page-export
    :catalog="SttrSearchCatalog"
    :params="Model.Search.ListParams"
    :search="searchData"
    @init="handleInit"
    @export="handleExport"
  >
    <Export
      :access="access"
      :userData="userData"
      @init="handleExport_init"
    />

    <kst-check disabled
      v-model="userData.WithList"
      :label="Info.Export.List.Excel.Option.List"
    />
    <kst-check 
      v-model="userData.WithItems"
      :label="Info.Export.List.Excel.Option.StockTrfItem"
    />
  </kst-page-export>
</template>

<script>
import Info from "../SttrInfo.js";
import Model from "../SttrModel.js";
import SttrSearchCatalog from "../SttrSearchCatalog.js";
import Services from "../../../services/Api/StockTrfServices.js";

import Export from "./SttrExL_Export.vue";

export default {
  components: {
    Export
  },
  data: () => ({
    Info: Info,
    Model: Model,
    SttrSearchCatalog: SttrSearchCatalog,
    access: {},
    searchData: {
      Search: "",
      Date: null,
      DestinationWarehouseID: null,
      SourceWarehouseID: null
    },
    userData: {
      WithList: true,
      WithItems: true
    },
    // func
    exportExcelFunc: null
  }),
  methods: {
    /*** by page ***/

    handleInit() {
      this.resetData();
    },

    handleExport(loadExport) {
      const options = this.getListOptions();
      const config = Services.getExportList(options);
      loadExport(config, this.handleExport_success);
    },
    handleExport_success(data, fileName) {
      this.exportExcelFunc(data, fileName);
    },

    /*** export ***/

    handleExport_init(exportExcel) {
      this.exportExcelFunc = exportExcel;
    },

    /*** custom ***/

    resetData() {
      this.access = this.$kst.Access.create(Model.Access);
      this.userData.WithList = true;
      this.userData.WithItems = true;
    },

    getListOptions() {
      return {
        startdate: this.$kst.Out.getDateString(this.searchData.Date[0]),
        enddate: this.$kst.Out.getDateString(this.searchData.Date[1]),
        dstwarehouse: this.$kst.Search.getValue(
          this.searchData.DestinationWarehouseID),
        srcwarehouse: this.$kst.Search.getValue(
          this.searchData.SourceWarehouseID),
        search: this.$kst.Out.getString(this.searchData.Search),
        field: Model.Search.ListFields,
        withitems: this.$kst.Out.getBoolean(this.userData.WithItems)
      };
    }
  }
}
</script>